import React from 'react';
import './Terms.css';

const translations = {
	'en': {
		title: 'Terms and Conditions',
		intro: 'By using this service, you agree to the following terms and conditions:',
		items: [
			'You confirm that the files you upload do not contain any illegal, harmful, or malicious content.',
			'You agree that the files you upload do not violate any copyright, trademark, or other intellectual property rights.',
			'You are solely responsible for the content of the files you upload and any consequences of their use or distribution.',
			'You agree to comply with all applicable laws and regulations while using this service.',
			'The service provider is not liable for any misuse of the files uploaded through this platform.',
			'The service provider reserves the right to remove any files that violate these terms without prior notice.',
			'Uploaded files are stored temporarily and will be automatically deleted after the expiration time specified during the upload process.',
			'The service provider does not guarantee the availability of files beyond their expiration time.',
			'The service provider implements reasonable security measures to protect uploaded files.',
			'The service provider will not access, view, or use the content of the uploaded files in any way, except as necessary to provide the service (e.g., for file storage and delivery).'
		],
		closing: 'If you do not agree to these terms, please do not use this service.'
	},
	'he': {
		title: 'תנאים והגבלות',
		intro: 'על ידי שימוש בשירות זה, אתה מסכים לתנאים ולהגבלות הבאים:',
		items: [
			'אתה מאשר שהקבצים שאתה מעלה אינם כוללים תוכן בלתי חוקי, מסוכן או זדוני.',
			'אתה מסכים שהקבצים אינם מפרים זכויות יוצרים, סימני מסחר או זכויות קניין רוחני אחרות.',
			'אתה אחראי באופן בלעדי לתוכן הקבצים ולהשלכותיהם.',
			'אתה מתחייב לציית לכל החוקים והתקנות החלים בעת שימוש בשירות זה.',
			'מפעיל השירות אינו אחראי לשימוש לרעה בקבצים שהועלו.',
			'מפעיל השירות שומר לעצמו את הזכות להסיר קבצים המפרים תנאים אלו ללא הודעה מוקדמת.',
			'הקבצים המועלים מאוחסנים באופן זמני וימחקו אוטומטית לאחר זמן הפקיעה שצוין בזמן ההעלאה.',
			'מפעיל השירות אינו מבטיח את הזמינות של הקבצים לאחר פקיעת הקישור.',
			'מפעיל השירות נוקט באמצעי אבטחה סבירים כדי להגן על הקבצים שהועלו.',
			'מפעיל השירות לא ייגש, יצפה או ישתמש בתוכן הקבצים המועלים אלא אם כן נדרש לצורך מתן השירות (למשל אחסון או מסירה).'
		],
		closing: 'אם אינך מסכים לתנאים אלה, אנא אל תשתמש בשירות זה.'
	},
	'ru': {
		title: 'Условия и положения',
		intro: 'Используя этот сервис, вы соглашаетесь со следующими условиями:',
		items: [
			'Вы подтверждаете, что загружаемые вами файлы не содержат незаконного, вредоносного или злонамеренного контента.',
			'Вы соглашаетесь, что файлы не нарушают авторские права, товарные знаки или другие права интеллектуальной собственности.',
			'Вы несёте полную ответственность за содержимое загружаемых файлов и последствия их использования или распространения.',
			'Вы обязуетесь соблюдать все применимые законы и нормативные акты при использовании сервиса.',
			'Поставщик сервиса не несёт ответственности за неправильное использование загруженных файлов.',
			'Поставщик сервиса оставляет за собой право удалять любые файлы, нарушающие эти условия, без предварительного уведомления.',
			'Загруженные файлы хранятся временно и будут автоматически удалены после истечения срока, указанного при загрузке.',
			'Поставщик сервиса не гарантирует доступность файлов после истечения срока.',
			'Поставщик сервиса внедряет разумные меры безопасности для защиты загруженных файлов.',
			'Поставщик сервиса не будет получать доступ, просматривать или использовать содержимое загруженных файлов, за исключением случаев, необходимых для предоставления услуги (например, для хранения и доставки).'
		],
		closing: 'Если вы не согласны с этими условиями, пожалуйста, не используйте этот сервис.'
	}
};

const detectLang = () => {
	const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
	const q = params && params.get('lang');
	if (q && ['en', 'he', 'ru'].includes(q)) return q;
	const nav = (typeof navigator !== 'undefined' && navigator.language) ? navigator.language.slice(0,2) : 'en';
	if (nav === 'he' || nav === 'iw') return 'he';
	if (nav === 'ru') return 'ru';
	return 'en';
};

const Terms = () => {
	const lang = detectLang();
	const txt = translations[lang] || translations.en;
	return (
		<div className="terms-container" dir={lang === 'he' ? 'rtl' : 'ltr'}>
			<h1>{txt.title}</h1>
			<p>{txt.intro}</p>
			<ul>
				{txt.items.map((it, idx) => <li key={idx}>{it}</li>)}
			</ul>
			<p>{txt.closing}</p>
		</div>
	);
};

export default Terms;
